import React from "react";
import _ from "underscore";
import { Row, Col, Button, Card } from "react-bootstrap";

import { Formik, Form, Field } from 'formik';
import {
  InputFloatingLabel
} from "../../formik";
import * as Yup from "yup";

import Alert from "react-s-alert";

import Actions from "../../redux/actions";

export class EditPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      canSubmit: false
    };
    this.userNew = this.userNew.bind(this);
    this.enableButton = this.enableButton.bind(this);
    this.disableButton = this.disableButton.bind(this);
  }

  enableButton() {
    this.setState({ canSubmit: true });
  }

  disableButton() {
    this.setState({ canSubmit: false });
  }

  userNew(user) {
    Alert.warning(this.props.intl.formatMessage({ id: "user.updating" }));
    this.props
      .dispatch(Actions.userChangePassword(_.omit(user, "confirmPassword")))
      .then(resp => {
        Alert.success(this.props.intl.formatMessage({ id: resp.message }));
      })
      .catch(err =>
        Alert.error(this.props.intl.formatMessage({ id: err.message }))
      );
  }
  
  render() {
    const PasswordSchema = Yup.object().shape({
      password: Yup.string().required().min(6, this.props.intl.formatMessage({
        id: "error.atleast6"
      })),
      confirmPassword: Yup.string().when("password", {
        is: val => (val && val.length > 0 ? true : false),
        then: Yup.string().oneOf(
          [Yup.ref("password")],
          this.props.intl.formatMessage({
            id: "error.passnomatch"
          })
        )
      })
    });
    return (
      <div className="add-box">
      <Card>
        <Card.Header>
          <h3 className="font-common-13">
            {this.props.intl.formatMessage({
              id: "button.changePassword"
            })}
          </h3>
          <Button variant="primary" className="close-ePass-modal" onClick={() => {
            this.props.onClose()
            this.props.setShow(true)
          } }><img alt="close" src="/icons/close.png" /></Button>
        </Card.Header>
        <Card.Body>
        <Formik
              validationSchema={PasswordSchema}
              onSubmit={(values) => {
                this.userNew(values)
                setTimeout(() => this.props.onClose(), 500)
                this.props.setShow(true)
              }}
              initialValues={
                {
                  password: '',
                  confirmPassword: '',
                }
              }
              render={({ values, setFieldValue }) => {
                return (
                  <Form className="input-custom floating-label-form">
                    <Row>
                      <Col sm={12}>
                        <Field
                          component={InputFloatingLabel}
                          type="password"
                          id="password"
                          name="password"
                          label={this.props.intl.formatMessage({
                            id: "input.password"
                          })}
                          placeholder={this.props.intl.formatMessage({
                            id: "input.password"
                          })}
                          required
                        />
                      </Col>
                      <Col sm={12}>
                        <Field
                          component={InputFloatingLabel}
                          type="password"
                          id="confirmPassword"
                          name="confirmPassword"
                          label={this.props.intl.formatMessage({
                            id: "input.password.confirm"
                          })}
                          placeholder={this.props.intl.formatMessage({
                            id: "input.password.confirm"
                          })}
                          required
                        />
                      </Col>
                    </Row>
                    <div className="add-box-btn">
                      <Row className="no-gutter">
                        <Col xs={12}>
                          <Button
                            className="font-common-13 btn-custom"
                            type="submit"
                            block
                          >
                            {this.props.intl.formatMessage({
                              id: "button.changePassword"
                            })}
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  </Form>
                )
              }}
            />
        </Card.Body>
      </Card>
    </div>
    );
  }
}


export default EditPassword
